import { useState } from 'react';

const useMobileThreadHeader = () => {
  const [messageInfoDrawerOpen, setMessageInfoDrawerOpen] = useState(false);

  const handleOpenMessageInfoDrawer = () => {
    setMessageInfoDrawerOpen(true);
  };

  const handleCloseMessageInfoDrawer = () => {
    setMessageInfoDrawerOpen(false);
  };

  return {
    messageInfoDrawerOpen,
    handleOpenMessageInfoDrawer,
    handleCloseMessageInfoDrawer,
  };
};

export { useMobileThreadHeader };
